import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_PARTNERS_OPTIONS_INIT,
});

export const success = data => ({
  type: PARTNER.GET_PARTNERS_OPTIONS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_PARTNERS_OPTIONS_FAILURE,
});

const getPartnersOptions = (ddi_uuid = false) => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getPartnersOptions(ddi_uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getPartnersOptions;
